import en from "./translation-website.en.json";
import ru from "./translation-website.ru.json";
import es from "./translation-website.es-419.json";
import pt from "./translation-website.pt-BR.json";
import fr from "./translation-website.fr.json";
import de from "./translation-website.de.json";
import it from "./translation-website.it.json";

// LANG - Uncomment the FR and DE languages to enable them
export const allowedLocales = ["ru", "es-la", "pt-br", "it", "fr", "de"];

export const normalizeLocale = (detected) => {
  if (!detected) return null;
  if (detected.startsWith("ru")) return "ru";
  if (detected.startsWith("es")) return "es-la";
  if (detected.startsWith("pt")) return "pt-br";
  if (detected.startsWith("it")) return "it";

  if (detected.startsWith("fr")) return "fr";
  if (detected.startsWith("de")) return "de";
  return null;
};

export const getMessages = (locale) => {
  switch (locale) {
    case "en":
      return en;
    case "ru":
      return ru;
    case "es-la":
      return es;
    case "pt-br":
      return pt;
    case "it":
      return it;
    case "fr":
      return fr;
    case "de":
      return de;
    default:
      if (locale.includes("ru")) return ru;
      if (locale.includes("es")) return es;
      if (locale.includes("pt")) return pt;
      if (locale.includes("it")) return it;
      if (locale.includes("fr")) return fr;
      if (locale.includes("de")) return de;
      return en;
  }
};
